/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Meal_TypesInputs */

const en_editor_meal_types = /** @type {(inputs: Editor_Meal_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meal`)
};

const de_editor_meal_types = /** @type {(inputs: Editor_Meal_TypesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mahlzeit`)
};

/**
* | output |
* | --- |
* | "Meal" |
*
* @param {Editor_Meal_TypesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const editor_meal_types = /** @type {((inputs?: Editor_Meal_TypesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Meal_TypesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_editor_meal_types(inputs)
	return en_editor_meal_types(inputs)
});